export default __webpack_public_path__ + "static/filter-button-anatomy-dark-e7b844f77acb577bece2a150cf05308a.png";